<template lang="pug">
  div
    el-row(type='flex')
      el-col.container-input
        validation-provider(:rules="{required: !isPA}", v-slot="{ errors }", name="Peças Técnicas/Gleba")
          app-label(label="Gleba:", :required="!isPA")
          el-input.input(
            v-model="cadastroColetivo.pecaTecnica.gleba",
            :class="{'erro' : errors.length}",
            @blur="whitespace('gleba')"
          )
          span.help.erro {{ errors[0] }}

      el-col.container-input
        validation-provider(rules="required", v-slot="{ errors }", name="Peças Técnicas/Interessado")
          app-label(label="Interessado:", :required="true")
          el-select.input(
            class="select",
            v-model="cadastroColetivo.pecaTecnica.interessado",
            placeholder="Selecione",
            value-key="id",
            name="Interessado",
            disabled,
            :class="{'erro' : errors.length}"
          )
            el-option(
              v-for="item in interessados",
              :key="item.id",
              :label="item.nome",
              :value="item"
            )
          span.help.erro {{ errors[0] }}
      el-col.container-input
        validation-provider(rules="required|min_value:0.00001", v-slot="{ errors }", name="Peças Técnicas/Area")
          app-label(label="Área a ser deduzida:", :required="true")
          app-double-input.input(
            v-model="cadastroColetivo.pecaTecnica.areaDeduzida",
            name='Área',
            :precision="4",
            :onkeypress="onlyInputNumbers",
            :class="{'erro' : errors.length}",
            :showAppend ="true"
        )
    el-row
      app-dados-responsavel(
        :responsavel="responsavel"
        :processo="{tipo: {codigo: 'ARRECADACAO'}}"
      )
    el-row
      app-documentos(
        aba="Georreferenciamento",
        :idUploadDocumento="'documentoGeorreferenciamento'",
        :titulo="'Georreferenciamento'",
        :maxSize='25000',
        :valid-extensions="extensoes",
        :documentos="documentos",
        :tiposDocumentos="tipoDocumentos",
        :tiposDocumentosObrigatorios="documentosObrigatorios",
        :pecasTecnicas="true",
        :observer="this.$refs.validation",
        @mudaTipo="mudaTipo",
        @setDadosPlanilha="setDadosPlanilha",
        @removedDoc="removeFile",
        @addedDoc="addedDoc",
      )
</template>

<script>
import AppLabel from '@/components/AppLabel'
import AppUploadArea from '@/components/AppUploadArea'
import { mapActions } from 'vuex'
import Divider from '@/screens/arrecadacao/components/Divider'
import FileHelper from '@/utils/fileHelper'
import cloneDeep from 'lodash/cloneDeep'
import AppDocumentos from '@/screens/central/components/cadastro/AppDocumentos.vue'
import AppDadosResponsavel from '@/components/shared/AppDadosResponsavel'
import AppDoubleInput from '@/components/AppDoubleInput'
import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import axios from '@/utils/api'

export default {
  mixins: [onlyInputNumbers],
  components: {
    AppLabel,
    AppUploadArea,
    Divider,
    AppDocumentos,
    AppDadosResponsavel,
    AppDoubleInput
  },

  data () {
    return {
      interessados: [],
      validExtensions: ['pdf'],
      urlUpload: this.$rotas.PUBLICO.UPLOAD,
      responsavel: {
        nome: '',
        codigoIncra: '',
        codigoCredenciamento: '',
        creaRnp: '',
        formacao: ''
      },
      extensoes: ['pdf', 'jpeg', 'png', 'docx', 'xls', 'xlsx', 'ods', 'zip', 'rar', 'jpg', 'doc'],
      documentos: [],
      tipoDocumentos: [],
      documentosObrigatorios: [],
      isPA: process.env.ESTADO === 'pa'
    }
  },

  async created () {
    await this.setDocumentos()
    if (this.isValidacao) {
      this.findAllInteressados().then(interessados => {
        this.interessados = interessados
        this.cadastroColetivo.pecaTecnica.interessado = this.interessados[0]
      })
    }

    await this.montarTela()
  },

  props: {
    cadastroColetivo: {
      type: Object,
      required: true
    },
    isValidacao: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions({
      findAllInteressados: 'interessadoArrecadacao/findAll',
      downloadDocumentos: 'documentoArrecadacao/download',
      findTiposDocumentoTipoProcesso: 'tipoDocumento/findTiposDocumentoTipoProcesso'
    }),

    setDadosPlanilha (valor) {
      this.cadastroColetivo.pecaTecnica.denominacaoImovel = valor.denominacao
      this.cadastroColetivo.pecaTecnica.jsonPlanilha = valor.jsonPlanilha
      this.cadastroColetivo.pecaTecnica.responsavel = this.responsavel
      this.cadastroColetivo.pecaTecnica.tipoPlanilha = valor.tipoPlanilha
    },

    addedDoc () {
      this.cadastroColetivo.pecaTecnica.documentos = this.documentos
    },

    async setDocumentos () {
      this.tipoDocumentos = await this.findTiposDocumentoTipoProcesso({
        url: 'geo',
        tipo: 'ARRECADACAO'
      })
      this.documentosObrigatorios = this.tipoDocumentos.filter(documento => {
        return !['GEOMETRIA_AREA_DEDUZIDA'].includes(documento.codigo)
      })
    },

    async removeFile (documento) {
      this.confirmBox(
        this.$messages.DOCUMENTO_REMOVE_CONFIRM,
        this.$messages.TITULO_WARNING,
        () => {
          if (documento.id) {
            axios({
              method: 'DELETE',
              url: `documento/delete`,
              data: documento,
              responseType: 'blob'
            })
              .then(() => {
                this.deleteAnexo(documento)
              })
              .catch(() => {
                this.showNotificacao(
                  this.$messages.TIPO_ERROR,
                  this.$messages.TITULO_ERROR,
                  'Houve um erro ao remover o anexo.'
                )
              })
          } else {
            this.deleteAnexo(documento)
          }
        },
        () => {}
      )
    },

    onSuccess (id, resumableFile, fileKey) {
      const documento = this.cadastroColetivo.pecaTecnica[id]

      this.cadastroColetivo.pecaTecnica[id] = {
        id: documento ? documento.id : null,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false
      }
    },

    async download (id) {
      const documento = this.cadastroColetivo.pecaTecnica[id]

      const arrayBuffer = await this.downloadDocumentos({ fileKey: documento.fileKey, id: documento.id })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    removerDocumento (id) {
      let documento = cloneDeep(this.cadastroColetivo.pecaTecnica[id])

      if (documento.id) {
        documento.removed = true
      } else {
        documento = null
      }

      this.cadastroColetivo.pecaTecnica[id] = documento
    },

    whitespace (field) {
      this.cadastroColetivo.pecaTecnica[field] = this.cadastroColetivo.pecaTecnica[field].trim()
    },

    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'MAPA_LOCALIZACAO':
        case 'LEITURA_MAPA':
          this.extensoes = ['pdf']
          break
        case 'GEOMETRIA_AREA_DEDUZIDA':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods']
          break
      }
    },
    montarTela () {
      const dadoPecaTecnica = this.cadastroColetivo?.pecaTecnica?.dadoPecaTecnica

      if (dadoPecaTecnica?.documentos) {
        this.documentos = dadoPecaTecnica?.documentos.map(d => {
          d.fileKey = d.fileKey
          d.fileName = d.nomeOriginal
          d.tipoDocumento.descricao = d.tipoDocumento.nome
          d.tipoDocumento.codigo = d.tipoDocumento.codigo
          d.id = d.id
          return d
        })
      }
      if (this.cadastroColetivo?.pecaTecnica?.responsavel) {
        this.responsavel = this.cadastroColetivo?.pecaTecnica?.responsavel
      } else {
        this.responsavel = {
          nome: '',
          codigoIncra: '',
          creaRnp: '',
          formacao: ''
        }
      }
      this.cadastroColetivo.pecaTecnica.dadoPecaTecnica.responsavel = this.responsavel
      this.responsavel.codigoIncra = this.cadastroColetivo?.pecaTecnica?.responsavel?.codigoCredenciamento
    }
  },

  activated () {
    this.findAllInteressados().then(interessados => {
      this.interessados = interessados
      this.cadastroColetivo.pecaTecnica.interessado = this.interessados[0]
    })
  },

  watch: {
    'cadastroColetivo.pecaTecnica.dadoPecaTecnica.responsavel' (val, oldVal) {
      if (val !== oldVal) {
        this.cadastroColetivo.pecaTecnica.dadoPecaTecnica.responsavel = this.responsavel
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.container-input {
  margin-right: 20px;
}

.select {
  width: 100%;
}

.el-textarea__inner {
  resize: none;
}

.upload-margin {
  margin-top: 1rem;
  margin-bottom: -1rem;
}

.divider-margin {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/gat/components/PecaTecnicaArcGis.vue